import { render, staticRenderFns } from "./Assignation.vue?vue&type=template&id=fa411a7c"
import script from "./Assignation.vue?vue&type=script&lang=js"
export * from "./Assignation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports